<template>
  <v-row>
    <v-col
      cols="12"
      md="6"
    >
      <v-select
        v-model="suplement_reduction.slug"
        :disabled="$store.state.app.onlyShow"
        :items="supRedFree"
        :label="ofertEBBDates.price_by_room ? $t('lbl.priceByRoom') : $t('lbl.priceByPax')"
        outlined
        dense
        hide-details
        item-text="name"
        item-value="slug"
        @change="setSupRed()"
      >
        <template v-slot:no-data>
          <v-list-item>
            <v-list-item-title>
              {{ ofertEBBDates.price_by_room ? $t('lbl.priceByRoom') : $t('lbl.priceByPax') }}
            </v-list-item-title>
          </v-list-item>
        </template>
      </v-select>
    </v-col>
    <v-col
      cols="12"
      md="2"
    >
      <v-tooltip
        v-if="room.suplement_reductions.length > 1 && !$store.state.app.onlyShow"
        top
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-2"
            v-bind="attrs"
            fab
            dark
            x-small
            color="error"
            v-on="on"
            @click="deleteSupRedRoomByPriceHotelOfertEBB({ pos: posHotel, posRoom: posRoom, posSup: pos })"
          >
            <v-icon small>
              {{ icons.mdiTrashCan }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('btn.delete') }}</span>
      </v-tooltip>

      <v-tooltip
        v-if="pos === 0 && !$store.state.app.onlyShow"
        top
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            dark
            x-small
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="addSupRedRoomByPriceHotelOfertEBB({ pos: posHotel, posRoom: posRoom })"
          >
            <v-icon small>
              {{ icons.mdiPlus }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('btn.insert') }}</span>
      </v-tooltip>
    </v-col>
    <v-col
      cols="12"
      md="3"
    >
      <v-text-field
        v-model="suplement_reduction.price"
        :label="$t('lbl.monto')"
        :disabled="$store.state.app.onlyShow"
        class="my-input"
        outlined
        dense
        hide-details
        type="number"
        prefix="$"
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import {
  mdiPlus,
  mdiArrowLeft,
  mdiSquareEditOutline,
  mdiDeleteOutline,
  mdiUpdate,
  mdiCalendarRange,
  mdiCancel,
  mdiDomain,
  mdiMenuDown,
  mdiMenuRight,
  mdiTrashCan,
  mdiArrowRightCircle,
  mdiArrowDownCircle,
} from '@mdi/js'

export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop, vue/prop-name-casing
    suplement_reduction: {
      type: Object,
    },
    // eslint-disable-next-line vue/require-default-prop
    room: {
      type: Object,
    },
    // eslint-disable-next-line vue/require-default-prop
    pos: {
      type: Number,
    },
    // eslint-disable-next-line vue/require-default-prop
    posRoom: {
      type: Number,
    },
    // eslint-disable-next-line vue/require-default-prop
    posHotel: {
      type: Number,
    },
    // eslint-disable-next-line vue/require-default-prop
    allSuplement: {
      type: Array,
    },
    // eslint-disable-next-line vue/require-default-prop
    allReductions: {
      type: Array,
    },
    // eslint-disable-next-line vue/require-default-prop
    edad: {
      type: Number,
    },
  },
  data() {
    return {
      rutaPublic: process.env.VUE_APP_API_URL_PLUBLIC,
      isLoading: true,
      icons: {
        mdiPlus,
        mdiArrowLeft,
        mdiSquareEditOutline,
        mdiDeleteOutline,
        mdiUpdate,
        mdiCalendarRange,
        mdiCancel,
        mdiDomain,
        mdiMenuDown,
        mdiMenuRight,
        mdiTrashCan,
        mdiArrowRightCircle,
        mdiArrowDownCircle,
      },
      modelConfig: {
        type: 'string',
        mask: 'YYYY-MM-DD',
      },
      modelTimeConfig: {
        type: 'string',
        mask: 'HH:mm',
      },
      loading: false,
      permisos: sessionStorage.getItem('permisos_auth'),
      itemsRooms: [],
      calculators: [],
      menuFromViaje: false,
      menuToViaje: false,
      menuFromReserva: false,
      menuToReserva: false,
      menuRooming: false,
      menuFromPagar: false,
      menuFecha: false,
      slug: null,
    }
  },
  computed: {
    ...mapState({
      ofertEBBDates: state => state.app.ofertEBBDates,
      allInclude: state => state.app.allInclude,
      onlyAdult: state => state.app.onlyAdult,
    }),
    supRedFree() {
      const result = []
      this.allSuplement.forEach(element => {
        if (this.allInclude) {
          if (
            element.slug !== 'suplemento-de-alimentacion-full-board-para-adultos-ap'
            && element.slug !== 'suplemento-de-alimentacion-full-board-ap'
            && element.slug !== 'suplemento-de-alimentacion-full-board-para-ninos-ap'
            && element.slug !== 'alimentacion-full-board-para-ninos-ap'
            && element.slug !== 'suplemento-de-cena-map'
            && element.slug !== 'suplemento-de-cena-para-adultos-map'
            && element.slug !== 'suplemento-de-cena-para-ninos-map'
            && element.slug !== 'cena-para-ninos-map'
            && element.slug !== 'suplemento-de-desayuno-para-adultos-cp'
            && element.slug !== 'suplemento-de-desayuno-para-ninos-cp'
            && element.slug !== 'desayuno-para-ninos-cp'
            && element.slug !== 'suplemento-de-desayuno'
            && element.slug !== 'suplemento-de-desayuno-cp'
          ) {
            result.push(element)
          }
        } else if (this.onlyAdult) {
          if (
            element.slug !== 'suplemento-de-alimentacion-full-board-para-adultos-ap'
            && element.slug !== 'suplemento-de-alimentacion-full-board-para-ninos-ap'
            && element.slug !== 'alimentacion-full-board-para-ninos-ap'
            && element.slug !== 'suplemento-de-cena-para-adultos-map'
            && element.slug !== 'suplemento-de-cena-para-ninos-map'
            && element.slug !== 'cena-para-ninos-map'
            && element.slug !== 'suplemento-de-desayuno-para-adultos-cp'
            && element.slug !== 'suplemento-de-desayuno-para-ninos-cp'
          ) {
            result.push(element)
          }
        } else {
          result.push(element)
        }
      })
      this.allReductions.forEach(element => {
        if (this.onlyAdult) {
          if (
            element.slug !== 'infantes'
            && element.slug !== '1er-infante'
            && element.slug !== '2do-infante'
            && element.slug !== '1er-adolescente'
            && element.slug !== '2do-adolescente'
            && element.slug !== '1-adulto-con-1-nino-se-cobra-como-2-adultos-en-dbl'
            && element.slug !== 'ninos'
            && element.slug !== '1er-nino'
            && element.slug !== '1er-nino-con-1-adulto'
            && element.slug !== '1er-nino-con-2-adultos'
            && element.slug !== '2do-nino'
            && element.slug !== '2do-nino-con-1-adulto'
            && element.slug !== '2do-nino-con-2-adultos'
            && element.slug !== '2-ninos-solos-en-una-hab-pagan-precio-pax-en-sgl'
            && element.slug !== '2-ninos-solos-en-una-hab-pagan-precio-pax-en-dbl'
            && element.slug !== 'ninos-solos-en-la-habitacion'
            && element.slug !== 'ninos-solos-en-una-habitacion-el-1er-nino'
            && element.slug !== 'ninos-solos-en-una-habitacion-el-2do-nino'
            && element.slug !== '1-adulto-infantes-en-una-habitacion-los-infantes'
            && element.slug !== '1-adulto-infantes-en-una-habitacion-1er-infante'
            && element.slug !== '1-adulto-infantes-en-una-habitacion-2do-infante'
            && element.slug !== '1-adulto-ninos-en-una-habitacion-los-ninos'
            && element.slug !== '1-adulto-ninos-en-una-habitacion-el-1er-nino'
            && element.slug !== '1-adulto-ninos-en-una-habitacion-el-2do-nino'
            && element.slug !== '2-adultos-infantes-en-una-habitacion-los-infantes'
            && element.slug !== '2-adultos-infantes-en-una-habitacion-1er-infante'
            && element.slug !== '2-adultos-infantes-en-una-habitacion-2do-infante'
            && element.slug !== '2-adultos-ninos-en-una-habitacion-los-ninos'
            && element.slug !== '2-adultos-ninos-en-una-habitacion-el-1er-nino'
            && element.slug !== '2-adultos-ninos-en-una-habitacion-el-2do-nino'
            && element.slug !== 'suplemento-de-desayuno-para-ninos-cp'
            && element.slug !== 'desayuno-para-ninos-cp'
            && element.slug !== 'suplemento-de-cena-para-ninos-map'
            && element.slug !== 'cena-para-ninos-map'
            && element.slug !== 'suplemento-de-alimentacion-full-board-para-ninos-ap'
            && element.slug !== 'alimentacion-full-board-para-ninos-ap'
          ) {
            result.push(element)
          }

          if ((element.slug === '1er-adolescente' || element.slug === '2do-adolescente') && this.edad <= 11) {
            result.push(element)
          }
        }
      })

      const allResult = []
      result.forEach(element => {
        let esta = false
        for (
          let index = 0;
          index < this.ofertEBBDates.hotels[this.posHotel].rooms_by_price[this.posRoom].suplement_reductions.length;
          // eslint-disable-next-line no-plusplus
          index++
        ) {
          if (
            this.ofertEBBDates.hotels[this.posHotel].rooms_by_price[this.posRoom].suplement_reductions[index].slug
              === element.slug
            && index !== this.pos
          ) {
            esta = true
          }
        }
        if (!esta) {
          allResult.push(element)
        }
      })

      return allResult.sort((a, b) => {
        const x = a.name
        const y = b.name

        if (x > y) {
          return 1
        }
        if (x < y) {
          return -1
        }

        return 0
      })
    },
  },
  methods: {
    ...mapMutations([
      'addSupRedRoomByPriceHotelOfertEBB',
      'deleteSupRedRoomByPriceHotelOfertEBB',
      'setSupRedRoomByPriceHotelOfertEBB',
    ]),
    setSupRed() {
      if (this.suplement_reduction.slug) {
        // eslint-disable-next-line camelcase
        let is_suplement = false
        // eslint-disable-next-line camelcase
        let suplement_reducc_id = null
        if (this.allSuplement.filter(e => e.slug === this.suplement_reduction.slug).length > 0) {
          // eslint-disable-next-line camelcase
          is_suplement = true
          // eslint-disable-next-line camelcase
          suplement_reducc_id = this.allSuplement.filter(e => e.slug === this.suplement_reduction.slug)[0].id
        } else if (this.allReductions.filter(e => e.slug === this.suplement_reduction.slug).length > 0) {
          // eslint-disable-next-line camelcase
          is_suplement = false
          // eslint-disable-next-line camelcase
          suplement_reducc_id = this.allReductions.filter(e => e.slug === this.suplement_reduction.slug)[0].id
        }

        // eslint-disable-next-line camelcase
        this.suplement_reduction.is_suplement = is_suplement
        // eslint-disable-next-line camelcase
        this.suplement_reduction.suplement_reducc_id = suplement_reducc_id

        /* this.setSupRedRoomByPriceHotelOfertEBB({
          pos: this.posHotel,
          posRoom: this.posRoom,
          posSup: this.pos,
          is_suplement,
          suplement_reducc_id,
        }) */
      }
    },
  },
}
</script>
<style scoped>
::v-deep .my-input .v-label,
::v-deep .my-input input {
  font-size: 12px !important;
  line-height: 1;
  min-height: 8px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
::v-deep .v-text-field__details {
  padding: 0 0 0 0;
}

::v-deep .my-input select {
  font-size: 12px !important;
  line-height: 1;
  min-height: 8px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>
